import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCreditsPortrait',
  props: {
    portraitUrl: null,
    name: null
  },
  setup(__props: any) {

// we there is a very old, but dedicated (square) portrait image profile S150 and S300.
// back then, we had a portrait format in the design, not a round square one.
// with the new images we ingested, the centering of the portrait image profile is off and cuts off the head.
// that's why we this component encapsulates this problem and makes it perfect for square profile pictures.


const NO_PORTRAIT_URL = '/appassets/img/no-actor-transparent.png';

return { __sfc: true,NO_PORTRAIT_URL }
}

})